import type { TolgeeInstance } from '@tolgee/web'
import type { TOptionsBase } from 'i18next'
import type { I18nPlugin } from '../types'

// biome-ignore lint/suspicious/noExplicitAny: there's no typings for this in the i18next lib
type Translator = any

export const TOLGEE_PROCESSOR_NAME = 'tolgeeProcessor'
export const tolgeeProcessor = (tolgee: TolgeeInstance): I18nPlugin => ({
  type: 'postProcessor',
  name: 'tolgeeProcessor',
  process: (value: string, keyIn: string[], options: TOptionsBase, translator: Translator) => {
    const keySeparator = options.keySeparator ?? translator?.options?.keySeparator ?? '.'

    // if namespace is in the key, we need to extract it
    // https://github.com/i18next/i18next/issues/2049
    const { key, namespaces } = translator.extractFromKey(keyIn.join(keySeparator), options)
    const ns = namespaces?.[0] ?? options.ns ?? translator?.options?.defaultNS

    if (options.noWrap) {
      return value
    }

    return tolgee.wrap({
      key,
      defaultValue: options.defaultValue as string | undefined,
      translation: value,
      ns,
    })
  },
})
